import { useQuery } from '@tanstack/react-query';
import { useCustomerProductPurchaseService } from '../services/customerProductPurchase.service';
import { CUSTOMER_QUERY_KEYS } from './customers.query';

export const CUSTOMER_PRODUCT_PURCHASE_QUERY_KEYS = {
  list: (customerId: string) =>
    [...CUSTOMER_QUERY_KEYS.all, 'product-purchases', customerId] as const,
} as const;

export function useCustomerProductPurchasesQuery(
  customerId: string | undefined
) {
  const service = useCustomerProductPurchaseService();

  return useQuery({
    queryKey: CUSTOMER_PRODUCT_PURCHASE_QUERY_KEYS.list(customerId ?? ''),
    queryFn: () => service.listProductPurchases(customerId!),
    enabled: !!customerId,
    refetchOnMount: 'always',
    retry: 1,
  });
}
